export default "__VITE_ASSET__C_bZfnjU__"